import React, { useContext, useState } from 'react'
import { useEffect } from 'react';
import { cartContext } from './../../Context/CartContext';
import LoadingScreen from './../LoadingScreen/LoadingScreen';
import { Link } from 'react-router-dom';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import $ from 'jquery'
import {Helmet} from "react-helmet";


export default function Cart() {
  
  const {get, remove, update, clear, cartData} = useContext(cartContext)
  const [cartContent, setcartContent] = useState(null)
  const [loading, setLoading] = useState(true);



  //  Get Cart Data to display it

  async function getCart() {
    let res = await get()
    setcartContent(res?.data)
    setLoading(false)
    console.log (res)
  
  }



  // Clear Cart products

  async function clearCart() {
    let res = await clear()
    setcartContent(res.data)
  }


  
  // remove product from Cart

  async function removeFromCart(id) {
    let res = await (remove(id))
    setcartContent(res.data)
    $('.remove').fadeIn(200, ()=> {
      setTimeout(() => {
        $('.remove').fadeOut(200)
      }, 1000);
    })
  }


  
  // Updating product count

  async function updateProductQty(id, count, idx) {
    let res = await (update(id, count))
    setcartContent(res?.data)
    $(`#update${idx}`).fadeIn(200, ()=> {
      setTimeout(() => {
        $(`#update${idx}`).fadeOut(200)
      }, 1000);
    })
  }

  useEffect(()=> {
    getCart()
  }, [])


  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Your Cart</title>
      </Helmet>
      
      {/* if no products in cart display no products img else display loading screen till fetching data */}

      {loading ? (
        <LoadingScreen />
      ) : cartContent?.products?.length > 0 ? (
        <section className="bg-main-light p-4 my-3">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="text-main fw-bold">Shopping Cart</h2>
            
            {/* link to payment */}

            <Link
              to={`/payment`}
              className="btn bg-main text-white fa-fade"
              style={{
                "--fa-animation-duration": "2s",
                "--fa-fade-opacity": 0.6,
              }}
            >
              {" "}
              Proceed to checkout{" "}
              {/* display Cart Items number */}
              {cartData?.numOfCartItems === null ? (
                0
              ) : (
                <span>({cartData?.numOfCartItems} items)</span>
              )}
            </Link>
          </div>
          <hr />

          {/*  display products in user Cart */}
          {cartContent.products.map((product, idx) => (
            <div key={idx} className="row align-items-center">
              <div className="col-md-2">

                {/* display product img and link it to product details*/}
                
                <Link to={`/productdetails/${product.product._id}`}>

                  <img
                    src={product.product.imageCover}
                    className="w-100 rounded-2"
                    alt={product.product.title}
                  />

                </Link>

              </div>

              {/* display product details */}

              <div className="col-md-10">

                {/* display product title */}

                <h4 className="h6  fw-bold">{product.product.title}</h4>

                {/* display product category */}

                <h6 className="text-main fw-semibold">
                  Category:{" "}
                  <span className="text-dark fw-normal">

                    {/* link to category of this product */}
                    <Link
                      className="hoveringClick"
                      to={`/categorydetails/${product?.product?.category?._id}`}
                    >
                      {product?.product?.category?.name}
                    </Link>

                  </span>{" "}
                  /{" "}
                  <span className="text-dark fw-normal normal">
                    {product.product.subcategory[0].name}
                  </span>{" "}
                </h6>
                
                {/* display product brand */}

                <h6 className="text-main fw-semibold">
                  Brand:{" "}
                  <span className="text-dark fw-normal">

                    {/* link to brand of this product */}

                    <Link
                      className="hoveringClick"
                      to={`/branddetails/${product?.product?.brand?._id}`}
                    >
                      {product?.product?.brand?.name}
                    </Link>

                  </span>

                </h6>

                {/* display price for one item */}

                <h6 className="text-main fw-semibold">

                  Price per Piece:{" "}

                  <span className="text-dark fw-normal">
                    {product?.price} EGP
                  </span>

                </h6>

                {/* display product Quantity*/}

                <h6 className="text-main fw-semibold">
                  {" "}
                  Quantity:{" "}
                  <span className="text-dark fw-normal">{product?.count}</span>
                </h6>

                {/* Handling and update product quantity  */}

                <div>

                  <div className="d-flex align-items-center">

                    {/* decrease product quantity */}

                    <button
                      onClick={() => {
                        updateProductQty(
                          product.product._id,
                          product.count <= 1 ? 1 : product.count - 1,
                          idx
                        );
                      }}
                      className="btn btn-outline-danger btn-sm rounded-circle"
                    >
                      <i className="fa-solid fa-minus"></i>
                    </button>

                    {/* display current quantity */}

                    <span className="fw-bold text-black-50 mx-3">
                      {" "}
                      {product.count}{" "}
                    </span>

                    {/* increase product count */}

                    <button
                      onClick={() => {
                        updateProductQty(
                          product.product._id,
                          product.count + 1,
                          idx
                        );
                      }}
                      className="btn Btn btn-sm rounded-circle"
                    >
                      <i className="fa-solid fa-plus"></i>

                    </button>

                  </div>

                  {/* Handling updating msg */}

                  <div
                    id={`update${idx}`}
                    className="alert alert-success msg mt-2"
                    style={{ display: "none" }}
                  >
                    Product Quantity updated successfully
                    <i className="ms-2 fs-5 fa-regular fa-thumbs-up"></i>
                  </div>

                </div>

                {/* Handling remove product from cart */}

                <div className="d-flex justify-content-between align-items-center mt-2">

                  {/* Remove product from cart button */}

                  <button
                    onClick={() => {
                      removeFromCart(product.product._id);
                    }}
                    className="btn btn-outline-danger btn-sm "
                  >
                    <i className="fa-regular fa-trash-can me-2"></i> Remove
                  </button>

                  {/* display total price */}

                  <h6 className="my-0">
                    Total Price:{" "}

                    <span className="text-main fw-bold">
                      {product.price * product.count} EGP
                    </span>

                  </h6>

                </div>

              </div>

              <hr className="my-3" />

            </div>
          ))}

          <div>

            {/* Handling remove product from cart msg */}

            <div
              className="alert alert-danger remove"
              style={{ display: "none" }}
            >
              Product removed successfully
            </div>

            {/* Handling clear Cart */}

            <div className="d-flex align-items-center justify-content-between">

              {/* clear Cart Button */}

              <button onClick={clearCart} className="btn btn-outline-danger">
                <RemoveShoppingCartIcon className="mb-1 me-2" />
                Empty Cart
              </button>

              {/* display total Cart price */}
              <h4 className="fs-5 text-muted text-end">
                Total Price:{" "}
                <span className="text-main fw-bold fs-4">
                  {cartContent.totalCartPrice} EGP
                </span>
              </h4>
            </div>
          </div>
        </section>
      ) : (

        // empty cart img in case no products in cart

        <div className="text-center py-1">
          <img
            className=""
            src={require("../../assets/images/Empty cart.png")}
            alt="empty-cart"
          />
          <div>

              {/* link to home in case of empty cart */}

            <h2 className="h4">
              {" "}


              <Link
                className="hoveringClick fw-bold fa-fade text-main"
                style={{
                  "--fa-animation-duration": "2s",
                  "--fa-fade-opacity": 0.6,
                }}
                to="/"
              >
                Shopping Now
              </Link>
            </h2>
          </div>
        </div>
      )}
    </>
  );
}


